import ManagedConnection from './ManagedConnection'
import type { OrgIntegration } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

export interface ManagedConnectionsProps {
  title: string
  connections: OrgIntegration[]
}

export default function ManagedConnections({ title, connections }: ManagedConnectionsProps) {
  if (connections.length === 0) return null

  return <section aria-label={title} className="rounded-xl border border-border bg-card p-5">
    <h2 className="mb-4 text-sm font-semibold text-foreground">{title}</h2>
    <div className="divide-y divide-border">
      {connections.map((connection) => <ManagedConnection key={connection.id} integration={connection} />)}
    </div>
  </section>
}
